import { Fragment } from "react"

const TableAlmacen = ({ datos }) => {
    return (
        <table className="table table-hover p-0 table-sm">
            <thead>
                <tr className="d-flex">
                    <th className="col-7 p-1 pl-md-4">
                        <div className="font-weight-bold">
                            <div className="row">
                                <div className="col-md-3">
                                    <span className="text-default">CÓDIGO SAP</span>
                                </div>
                                <div className="col-md-9">
                                    <span className="text-default">DENOMINACIÓN</span>
                                </div>
                            </div>
                        </div>
                    </th>
                    <th className="col-3">
                        <div className="row font-weight-bold text-center">
                            <div className="col-md-4">
                                <span className="text-info">Und</span>
                            </div>
                            <div className="col-md-4">
                                <span className="text-gray">Stock</span>
                            </div>
                            <div className="col-md-4">
                                <span className="text-teal">P.Unit</span>
                            </div>
                        </div>
                    </th>
                    <th className="col-2 p-1 pr-md-2 text-right">
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    (datos.lista) && (

                        datos.lista.map((sap, index) => {
                            return (
                                <Fragment key={`${sap}${index}`}>
                                    <tr key={sap.codigoSap} className="d-flex ">
                                        <td className="col-7 p-1 pl-md-4">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <span className="font-weight-bold">{sap.codigoSap}</span>
                                                </div>
                                                <div className="col-md-9">
                                                    <span>{sap.denominacion}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="col-3">
                                            <div className="row text-center">
                                                <div className="col-md-4">
                                                    <span className="text-info">{sap.unidad}</span>
                                                </div>
                                                <div className="col-md-4">
                                                    <span className="text-gray">{sap.stock}</span>
                                                </div>
                                                <div className="col-md-4">
                                                    <span className="text-teal">{sap.pUnitario}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="col-2 p-1 pr-md-2 text-right">
                                            {
                                                (sap.img.length > 0) && <a href={`#toggle${index}`} className="btn btn-primary accordion-toggle" data-toggle="collapse"><i className="fas fa-camera"></i></a>
                                            }
                                        </td>
                                    </tr>
                                    {
                                        (sap.img.length > 0) &&
                                        <tr>
                                            <td colSpan="3" className="bg-light p-0 border-0">
                                                <div className="collapse" id={`toggle${index}`}>
                                                    <div className="p-0">
                                                        <h2 className="text-center pt-3">{sap.codigoSap} - {sap.denominacion}</h2>
                                                        <div className="d-flex flex-wrap justify-content-center">
                                                            {
                                                                sap.img.map((data, index) => {
                                                                    return (
                                                                        <div className="m-3 p-2 card text-center" key={index}>
                                                                            <a href={`https://sisweb.tekbimed.com/assets/images/equipos/mediano/${data.nombre}`} target="_blank">
                                                                                <img src={`https://sisweb.tekbimed.com/assets/images/equipos/miniatura/${data.nombre}`} alt="..." className="img-thumbnail" style={{ maxHeight: "350px" }} />
                                                                            </a>
                                                                            <div className="pt-2 text-left">
                                                                                <ul>
                                                                                    <li>{data.detalle}</li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }


                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </Fragment>
                            )
                        })
                        
                    )
                }
            </tbody>
        </table >
    )
}
export default TableAlmacen